module.exports = __webpack_public_path__ + "img/beagle.8bd07f5d.jpg";